import { render, staticRenderFns } from "./CampoClientEmailFacturacion.vue?vue&type=template&id=236a588c&scoped=true"
import script from "./CampoClientEmailFacturacion.vue?vue&type=script&lang=js"
export * from "./CampoClientEmailFacturacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236a588c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('236a588c')) {
      api.createRecord('236a588c', component.options)
    } else {
      api.reload('236a588c', component.options)
    }
    module.hot.accept("./CampoClientEmailFacturacion.vue?vue&type=template&id=236a588c&scoped=true", function () {
      api.rerender('236a588c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/components/CampoClientEmailFacturacion.vue"
export default component.exports